import React from "react";
import { useLocation, Link } from "react-router-dom";

const PoolCarePurchaseSuccess = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const listingId = params.get("listingId");

  return (
    <div style={{ textAlign: "center", marginTop: 120, padding: "0 20px" }}>
      <h1 style={{ color: "#0b6b2d" }}>✅ Pool Care Listing Activated</h1>

      <p>
        Your pool care listing has been successfully activated and is now
        visible to buyers.
      </p>

      {listingId && (
        <div
          style={{
            background: "#f1f8f4",
            padding: "12px",
            borderRadius: "8px",
            margin: "20px auto",
            maxWidth: 420,
            fontWeight: 600,
          }}
        >
          Listing ID: {listingId}
        </div>
      )}

      <p style={{ color: "#555", maxWidth: 520, margin: "0 auto" }}>
        You have paid a <strong>one-time listing activation fee</strong> equal to
        <strong> 25% of your listing price</strong>. This fee activates your
        listing and makes it visible on Client Exchange.
      </p>

      <div style={{ marginTop: 30 }}>
        <Link
          to="/dashboard"
          style={{
            padding: "12px 22px",
            background: "#0b6b2d",
            color: "white",
            textDecoration: "none",
            borderRadius: "6px",
            marginRight: "12px",
          }}
        >
          Go to Dashboard
        </Link>

        {listingId && (
          <Link
            to={`/poolcare/listing/${listingId}`}
            style={{
              padding: "12px 22px",
              background: "#333",
              color: "white",
              textDecoration: "none",
              borderRadius: "6px",
            }}
          >
            View Listing
          </Link>
        )}
      </div>
    </div>
  );
};

export default PoolCarePurchaseSuccess;
